/* eslint react/jsx-key: 0 */

/** @jsx CanvaSX */
import { CanvaSX } from '@lib/canvasx/canvasx';
import { FlexRow } from '@lib/canvasx/components/FlexRow';
import RecordCard, {
  type RecordCardProps,
  availableContentWidth,
} from './RecordCard';
import { Rect } from '@lib/canvasx/components/Rect';
import { type CardData, renderFieldContents } from './fieldContents';
import Divider from './CardDivider';

export type CardContentsProps = Pick<RecordCardProps, 'setRenderedDimensions'> &
  Pick<ShapeStruct, 'width' | 'height'> & {
    cardData: CardData;
    opacity?: number;
  };

export const CardContents: CanvaSXFC<CardContentsProps> = function ({
  cardData,
  height,
  width,
  setRenderedDimensions,
  opacity = 1,
}) {
  const { content, styling } = cardData;
  const contentWidth = availableContentWidth(width);

  return (
    <RecordCard
      backgroundColor={styling.backgroundColor}
      highlightColor={styling.highlightColor}
      width={width}
      height={height}
      setRenderedDimensions={setRenderedDimensions}
      opacity={opacity}
    >
      {content.map(row => {
        if (row.type === 'divider') {
          return <Divider width={contentWidth} />;
        }
        const [firstGroupContent, secondGroupContent] = row.content;
        const firstGroupFields = firstGroupContent
          .map(renderFieldContents)
          .filter(Boolean);
        const secondGroupFields = secondGroupContent
          .map(renderFieldContents)
          .filter(Boolean);

        return (
          <FlexRow
            width={contentWidth}
            verticalAlignment='center'
            gap={{ horizontal: 7, vertical: 0 }}
          >
            {[
              ...firstGroupFields,
              secondGroupFields.length ? <Rect height={1} flexGrow /> : null,
              ...secondGroupFields,
            ].filter(Boolean)}
          </FlexRow>
        );
      })}
    </RecordCard>
  );
};
